var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('MypageSubTitle'), _c('div', {
    staticClass: "ptc_container"
  }, [_c('MypageWritingSubTitle'), _vm.processDetailActive === true ? _c('processDetail', {
    attrs: {
      "processDetailData": _vm.processDetailData,
      "thisMyPage": true
    },
    on: {
      "goToProcessEditor": function ($event) {
        return _vm.goToProcessEditor(_vm.processDetailData);
      },
      "goToProtocolDetail": _vm.goToProtocolDetail,
      "goToList": function ($event) {
        return _vm.goToList(0);
      }
    }
  }) : _vm._e(), _vm.processDetailActive === false ? _c('protocolDetail', {
    attrs: {
      "protocolDetailData": _vm.protocolDetailData,
      "thisMyPage": true
    },
    on: {
      "goToProtocolEditor": function ($event) {
        return _vm.goToProtocolEditor(_vm.protocolDetailData);
      },
      "goToProcessDetail": function ($event) {
        return _vm.goToProcessDetail(_vm.protocolDetailData.processId, 0);
      },
      "goToProtocolDetail": _vm.goToProtocolDetail,
      "goToList": function ($event) {
        return _vm.goToList(1);
      }
    }
  }) : _vm._e()], 1), _c('Loading', {
    attrs: {
      "visible": _vm.loading,
      "type": "fixed"
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }